function Error({ err, onRetry }) {
  return (
    <div role="alert" className="pa-alert">
      <i
        className="bi bi-exclamation-triangle-fill pa-alert__icon"
        aria-hidden="true"
      ></i>
      <div className="flex-grow-1">
        <p className="mb-1 fw-bold">Une erreur est survenue.</p>
        <p className="mb-0 pa-small pa-muted">{err}</p>
      </div>
      {onRetry && (
        <button
          type="button"
          className="pa-btn pa-btn--danger pa-btn--sm flex-shrink-0"
          onClick={onRetry}
        >
          Réessayer
        </button>
      )}
    </div>
  );
}

export default Error;
